import { Stacked } from '@statsbomb/kitbag-components';
import { Legend } from '@statsbomb/kitbag-datavis';
import { useAtomValue } from 'jotai';
import { useRef } from 'react';
import { pitchMarkerColouringModeAtom, showArrowsAtom, showLegendAtom } from '@/atoms/visualisation';
import { PitchMarkerColouringMode } from '@/types/visualisation';
import { EventMapArrowMarkerLegend } from './EventMapArrowMarkerLegend';
import { EventMapMarkerLegend } from './EventMapMarkerLegend';
import { EventMapObvLegend } from './EventMapObvLegend';
import { EventMapShotMarkerLegend } from './EventMapShotMarkerLegend';
import { EventMapXgGradient } from './EventMapXgGradient';
import { EventMapXgLegend } from './EventMapXgLegend';

const getEventMapLegendComponent = (showArrows: boolean, pitchMarkerColouringMode: PitchMarkerColouringMode) => {
  if (pitchMarkerColouringMode === 'xg') {
    return <EventMapXgLegend />;
  }

  if (pitchMarkerColouringMode === 'obv') {
    return <EventMapObvLegend />;
  }

  return showArrows ? <EventMapArrowMarkerLegend /> : <EventMapMarkerLegend />;
};

const getShotMarkerColourScale = (pitchMarkerColouringMode: PitchMarkerColouringMode) =>
  pitchMarkerColouringMode === 'obv' ? <EventMapObvLegend /> : <EventMapXgGradient />;

export const EventMapLegend = ({ hasShotMarkers = false }: { hasShotMarkers?: boolean }) => {
  const legendRef = useRef<HTMLLegendElement>(null);
  const showLegend = useAtomValue(showLegendAtom);
  const showArrows = useAtomValue(showArrowsAtom);
  const pitchMarkerColouringMode = useAtomValue(pitchMarkerColouringModeAtom);

  if (!showLegend) {
    return null;
  }

  if (hasShotMarkers) {
    return (
      <Legend legendRef={legendRef}>
        <Stacked direction="column">
          {getShotMarkerColourScale(pitchMarkerColouringMode)}
          <EventMapShotMarkerLegend />
        </Stacked>
      </Legend>
    );
  }

  if (pitchMarkerColouringMode === 'default') {
    return null;
  }

  const eventMapLegendComponent = getEventMapLegendComponent(showArrows, pitchMarkerColouringMode);

  return <Legend legendRef={legendRef}>{eventMapLegendComponent}</Legend>;
};
